import { Controller } from '@hotwired/stimulus';
import { Tooltip } from 'bootstrap';

export default class extends Controller {
  static values = {
    copiedText: String,
    textToCopy: String,
    withTooltip: { type: Boolean, default: true },
  };

  disconnect() {
    clearTimeout(this.tooltipTimeout);
    clearTimeout(this.elementTimeout);
  }

  copyTextValue(event) {
    event.preventDefault();

    const targetValue = event.currentTarget.dataset.targetValue;

    navigator.clipboard.writeText(targetValue);

    if (this.withTooltipValue) {
      this.#updateTooltipWording(event.currentTarget);
    } else {
      this.#updateElementWording(event.currentTarget);
    }
  }

  #updateTooltipWording(item) {
    clearTimeout(this.tooltipTimeout);

    let btnTooltip = Tooltip.getInstance(item);
    btnTooltip.setContent({ '.tooltip-inner': this.copiedTextValue });
    btnTooltip.show();

    this.tooltipTimeout = setTimeout(() => {
      btnTooltip.setContent({ '.tooltip-inner': this.textToCopyValue });
      btnTooltip.hide();
      item.blur();
    }, 2000);
  }

  #updateElementWording(item) {
    clearTimeout(this.elementTimeout);

    item.textContent = this.copiedTextValue;

    this.elementTimeout = setTimeout(() => {
      item.textContent = this.textToCopyValue;
    }, 3000);
  }
}
